// extracted by mini-css-extract-plugin
export default {"element-outer":"pagebutton_element-outer__H6K+S","element-clickable":"pagebutton_element-clickable__geW9A","tooltip":"pagebutton_tooltip__7WZxP"};